<template>
  <div
    :class="[
      bem.b(),
      bem.is(size),
      bem.is(variant),
      reverse ? bem.is('reverse') : '',
    ]"
  >
    <!-- 前缀 -->
    <div v-if="$slots.prefix || prefix" :class="bem.e('prefix')">
      <slot name="prefix">{{ prefix }}</slot>
    </div>

    <slot name="value">
      <span :class="bem.e('value')">{{ value }}</span>
    </slot>

    <!-- 后缀 -->
    <div v-if="$slots.suffix || suffix" :class="bem.e('suffix')">
      <slot name="suffix">{{ suffix }}</slot>
    </div>

    <!-- 标记 -->
    <ll-icon
      icon-name="icon-solid-arrow-folding"
      :style="{ rotate: `${type === 'up' ? 0 : 180}deg` }"
      :class="bem.e('icon')"
    />
  </div>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'

import { trendProps } from './trend'

defineOptions({ name: 'LlTrend' })

const props = defineProps(trendProps)

const bem = createNamespace('trend')
</script>
